import keyMirror from 'key-mirror';
import { deepFreeze } from '@mw/helpers';

import { AgentProviders, ChannelType } from './common';

export const MessageStatus = keyMirror({
  SENT: null,
  READ: null,
  DELIVERED: null,
  ERROR: null,
  UNDELIVERABLE: null,
  CREATED: null,
  UPLOAD_ERROR: null,
});

export const MessageType = keyMirror({
  TEXT: null,
  FILE: null,
  CAROUSEL: null,
  REPLY: null,
  CARD: null,
  LIST: null,
  LOCATION: null,
  IMAGE_LIST: null,
  CONTACT: null,
  RESET_KEYBOARD: null,
  STICKER: null,
  VOICE: null,
});

export const MessageTemplateType = {
  [MessageType.CARD]: 'CARD_TEMPLATE',
  [MessageType.TEXT]: 'TEXT_TEMPLATE',
  [MessageType.LIST]: 'LIST_TEMPLATE',
  [MessageType.CAROUSEL]: 'CAROUSEL_TEMPLATE',
};

export const ErrorMessageTemplateType = {
  CARD_TEMPLATE: 'Cannot delete card',
  LIST_TEMPLATE: 'Cannot delete button menu',
};

export const MessageFileCategories = keyMirror({
  IMAGE: null,
  VIDEO: null,
});

export const MAXIMUM_MESSAGE_LENGTH = 4096;
export const MAXIMUM_SMS_AMOUNT_LENGTH = 10;

export const MAXIMUM_MESSAGE_LENGTH_BY_PROVIDERS_MAP = deepFreeze({
  [AgentProviders[ChannelType.RCS].RBM]: 3072,
  [AgentProviders[ChannelType.WECHAT].TENCENT]: 2048,
  [AgentProviders[ChannelType.VI].VIBER]: 1000,
});

export const SRC_PLACEHOLDER = 'SRC_PLACEHOLDER';
